<div class="login-page" data-bs-theme="dark">
  <div class="login-container">
    <!-- Logo and Header -->
    <div class="text-center mb-4">
      <img [src]="logo" alt="ADN Logo" class="login-logo" />
      <h2 class="h3 mb-2">Forgot Password</h2>
      <p class="text-muted">Enter your email address and we'll send you instructions to reset your password</p>
    </div>

    @if (errorMessage) {
      <div class="alert alert-danger" role="alert">
        <i class="bi bi-exclamation-triangle me-2"></i>
        {{ errorMessage }}
      </div>
    }

    @if (successMessage) {
      <div class="alert alert-success" role="alert">
        <i class="bi bi-envelope-check me-2"></i>
        {{ successMessage }}
      </div>
    }

    <div>
      <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <label for="email" class="form-label">Email Address <span class="text-danger">*</span></label>
          <input
            type="email"
            class="form-control"
            id="email"
            formControlName="email"
            placeholder="you@example.com"
            [class.is-invalid]="forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched"
            autocomplete="email"
          />
          @if (forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched) {
            <div class="invalid-feedback">Please enter a valid email address</div>
          }
        </div>

        <button
          type="submit"
          class="btn btn-primary w-100 mt-2"
          [disabled]="loading || forgotForm.invalid"
        >
          @if (loading) {
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          }
          {{ loading ? 'Sending...' : 'Send password reset email' }}
        </button>

        <div class="text-center mt-3">
          <button
            type="button"
            class="btn btn-link p-0"
            (click)="goBackToLogin()"
            [disabled]="loading"
          >
            <i class="bi bi-arrow-left me-2"></i>
            Back to Login
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
